<template>
  <div class="not-authorized">
    <h1>403 - Not Authorized</h1>
    <p>You do not have permission to access this page.</p>
    <router-link to="/">Go to Home</router-link>
  </div>
</template>

<script>
export default {
  name: 'NotAuthorized403'
};
</script>

<style scoped>
.not-authorized {
  text-align: center;
  margin-top: 50px;
}

.not-authorized h1 {
  font-size: 3em;
  margin-bottom: 20px;
}

.not-authorized p {
  font-size: 1.5em;
  margin-bottom: 20px;
}
</style>